import { render, staticRenderFns } from "./wode-dingyue.vue?vue&type=template&id=52b990ac&"
import script from "./wode-dingyue.vue?vue&type=script&lang=js&"
export * from "./wode-dingyue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports